import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import logo from '../components/global/logo';
import dealCard from '../components/global/deal/card';
import dealTr from '../components/global/deal/tr';
import dealStatus from '../components/global/deal/status';
import dealSearch from '../components/global/deal/search';

import comment from '../components/global/comment';
import userCard from '../components/global/user/card';
import userAvatar from '../components/global/user/avatar';
import userSelect from '../components/global/user/select';
import ghostMessage from '../components/global/ghostMessage';
import tagSelect from '../components/global/tag/select';
import tagTypes from '../components/global/tag/types';

import couponCard from '../components/global/coupon/card';
import couponTr from '../components/global/coupon/tr';

import bannerCard from '../components/global/banner/card';

import TiptapEditor from '../components/global/editor/TiptapEditor';

import ValidationObserver from '../components/compat/ValidationObserver';
import ValidationProvider from '../components/compat/ValidationProvider';
import AIcon from '../components/compat/AIcon';

// eslint-disable-next-line import/prefer-default-export
export function registerComponents(app) {
	// CUSTOM
	app.component('Logo', logo);
	app.component('DealCard', dealCard);
	app.component('DealTr', dealTr);
	app.component('DealStatus', dealStatus);
	app.component('DealSearch', dealSearch);

	app.component('Comment', comment);
	app.component('UserCard', userCard);
	app.component('UserAvatar', userAvatar);
	app.component('UserSelect', userSelect);
	app.component('GhostMessage', ghostMessage);
	app.component('TagSelect', tagSelect);
	app.component('TagTypes', tagTypes);

	app.component('CouponCard', couponCard);
	app.component('CouponTr', couponTr);

	app.component('BannerCard', bannerCard);

	app.component('TiptapEditor', TiptapEditor);

	// VEE-VALIDATE COMPAT SHIMS (v2/v3 API → v4 migration)
	app.component('ValidationObserver', ValidationObserver);
	app.component('ValidationProvider', ValidationProvider);

	// ANT DESIGN ICON COMPAT SHIM (a-icon type="xxx" → @ant-design/icons-vue)
	app.component('AIcon', AIcon);

	// THIRD PARTY
	app.component('FaIcon', FontAwesomeIcon);
}
